import type { BufferEditor } from '../../../BufferEditor/types.plate'
import { EditorEntityData } from '../../../helpers/EditorEntityData'
import { hasOnlyFacebookGroupsSelected } from '../queries/hasOnlyFacebookGroupsSelected'
import { insertFacebookMention } from '../transforms/insertFacebookMention'

// Serves as the `textToNodes` callback for the facebook-mention plugin.
// It uses the facebook mention entities stored and provided to convert
// the text at the given indices to facebook mention elements.
export const findAndInsertFacebookMentions = (
  editor: BufferEditor,
  { entities }: { entities?: EditorEntityData } = {},
): void => {
  if (hasOnlyFacebookGroupsSelected(editor)) return

  if (entities) {
    EditorEntityData.getFacebookMentions(entities).forEach(
      (facebookMention) => {
        insertFacebookMention(editor, facebookMention)
      },
    )

    // Move selection to end of editor content
    const editorEndPoint = editor.api.end([])
    if (editorEndPoint) {
      editor.tf.select({
        anchor: editorEndPoint,
        focus: editorEndPoint,
      })
    }
  }
}
